<template>
  <BoxListEmptyCard v-if="boxList && !boxList.items.length"></BoxListEmptyCard>

  <b-list-group v-else class="list-cards">
    <ItemListCard
      v-for="box in filteredBoxList"
      :key="box.uid"
      :item="box"
      @click.native="goToBox(box)"
    >
      <template slot="Decorator">
        <span class="decorator">
          <i
            v-if="Constants.boxTypes.SMARTBOX.key.localeCompare(box.type) == 0 || Constants.boxTypes.SMARTBOX.value == box.type"
            class="fas fa-bolt"
            title="Smartbox"
          ></i>
          <i v-else class="fas fa-box"></i>
        </span>
      </template>
      <template slot="Content"></template>
      <template slot="QuickStats">
        <div class="stats-wrapper stats-wrapper--right">
          <div class="stat-item" v-if="box.type === 'BOX'">
            <span class="stats-value"> {{ pad.call(getMinSec(box.statistics.durationAverage).min) }}:{{ pad.call(getMinSec(box.statistics.durationAverage).sec) }}</span>
            <i
                    class="far fa-clock"
                    v-tooltip="{
                      data: 'Average duration'
                    }">
            </i>
          </div>

          <div class="stat-item" v-if="box.type === 'BOX'">
            <span class="stats-value">{{box.statistics.trackCount}}</span>
            <i
                    class="far fa-dot-circle"
                    v-tooltip="{
                      data: 'Track count',
                      arrowPosition: 'top'
                    }"
            ></i>
          </div>

          <div class="stat-item">
            <span class="stats-value">{{box.artistRepeatDelay}}</span>
            <i
                    class="fas fa-user-clock"
                    v-tooltip="{
                      data: 'Artist repeat delay',
                      arrowPosition: 'left'
                    }"></i>
          </div>

          <div class="stat-item">
            <span class="stats-value">{{box.trackRepeatDelay}}</span>
            <i
                    class="fas fa-history"
                    v-tooltip="{
                      data: 'Track repeat delay',
                      arrowPosition: 'right'
                    }"></i>
          </div>
        </div>
      </template>
      <template slot="Menu">
        <b-dropdown no-caret>
          <template slot="button-content">
            <i class="fas fa-ellipsis-v"></i>
          </template>
          <b-dropdown-item v-on:click="startEditBox(box)">Settings...</b-dropdown-item>
          <b-dropdown-item v-on:click="startDuplicateBox(box)">Duplicate</b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item v-on:click.stop="startDeleteBox(box)">Delete box</b-dropdown-item>
        </b-dropdown>
      </template>
    </ItemListCard>
  </b-list-group>
</template>

<script>
import store from "@/store";
import Constants from "@/store/constants";
import router from "@/router";
import ItemListCard from "@/components/common/PlannerItemListCard.vue";
import EventBus from "@/eventbus";
import { mapState } from "vuex";
import BoxListEmptyCard from "./BoxListEmptyCard";


export default {
  name: "BoxList",
  router,
  components: { BoxListEmptyCard, ItemListCard},
  computed: {
    Constants: () => Constants,
    ...mapState({
      isLoadingBoxes: function() {
        return store.state.loadingStates.isLoadingStationBoxes;
      },
      boxList: function() {
        return store.state.stationBoxes;
      },
      currentStationUid: function() {
        return store.state.currentStationUid;
      }
    }),
    trackTypeParameter: function() {
      return this.$route.params.boxType;
    },
    hasQueryBoxesType() {
      if(this.$route.query && Object.keys(this.$route.query).length){
        return this.$route.query
      }
    },
    isMusicTab: function() {
      return this.trackTypeParameter === Constants.trackTypes.MUSIC.key;
    },
    filteredBoxList() {
      return this.boxList && this.boxList.items.filter(box => this.isBoxVisible(box));

    }
  },
  data() {
    return {
      currentBox: null,
    };
  },
  methods: {
    isBoxVisible(box) {
      const sameTrackType = box.trackType === this.trackTypeParameter;

      // check first if there is a query on url
      if(this.hasQueryBoxesType){

      /*
      * On load of page, query value is a String type so do two tests, one with a string comparison and another one with a Boolean
      * */

        // show only music boxes.
        if(sameTrackType && (this.hasQueryBoxesType.box === 'true' || this.hasQueryBoxesType.box === true)) {
          return box.type === Constants.boxTypes.BOX.key
        }

        // only show smart boxes
        if(this.hasQueryBoxesType.smartBox === 'true' || this.hasQueryBoxesType.smartBox === true) {
          return box.type === Constants.boxTypes.SMARTBOX.key
        }
      } else {
        // return all sections
        return sameTrackType;
      }

      // all type ( music and smart boxes)
      // if (this.isMusicTab) {
      //   return sameTrackType;
      // } else {
      //   return box.trackType === this.trackTypeParameter
      // }
    },
    onCreateClockClicked() {
      console.log("Box List");
    },
    getMinSec(ms) {
      let sec = parseInt(ms / 1000);
      const hours = parseInt(sec / 3600); // 3,600 sec in 1 hour
      sec = sec % 3600; // sec remaining after extracting hours
      let min = parseInt(sec / 60); // 60 sec in 1 minute
      sec = sec % 60;

      return { sec, min };
    },
    startEditBox(box) {
      EventBus.$emit("onBoxEdition", box.uid);
    },
    startDuplicateBox(box) {
      EventBus.$emit("onBoxDuplicate", box.uid);
    },
    startDeleteBox(box) {
      console.log('startDeleteBox')
      EventBus.$emit("onBoxDelete", box);
    },
    boxDeleted() {
      console.log("deleted");
    },
    goToBox(box){
      this.$router.push({
        name:'BoxDetails',
        params:{
          boxUid: box.uid
        }
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.list-card {
  padding-left: 35px;

  .menu {
    margin-left: 20px;
  }
}

.box-list__item--tooltip--info {
  font-size: 11px;
  font-weight: 600;
  line-height: 30px;
  text-transform: uppercase;
}
</style>
